import { Guid } from '../../models';

export function useDataRoomSessionQuery(guid: Guid | undefined, userGuid: Guid | null | undefined) {
	const cookie = document.cookie?.split('; ').find(cookie => cookie.includes('DataRoomSession'));
	const value = cookie ? cookie.split('=')[1] : '';
	return value == userGuid && cookie != undefined;
}
